export default "assets/images/texture_newsletter-f3ae1d70.png";